import React, { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    // Function to handle sidebar collapse state
    const handleSidebarCollapse = (collapsed: boolean) => {
        setIsCollapsed(collapsed);
    };

    return (
        <div className="flex flex-col min-h-screen pt-16">
            <Header />

            <div className="flex flex-1">
                <Sidebar onCollapseChange={handleSidebarCollapse} />

                <main
                    className={`flex-1 ${
                        isCollapsed ? "ml-16" : "ml-64"
                    } pb-20 transition-all duration-300`}
                >
                    <div className="container mx-auto px-6 py-8">
                        {children}
                    </div>
                </main>
            </div>

            <div
                className={`mt-auto ${
                    isCollapsed ? "ml-16" : "ml-64"
                } transition-all duration-300`}
            >
                <Footer />
            </div>
        </div>
    );
};

export default Layout;
